import * as angular from 'angular';
import {$bringozFactory} from "../../persistence-layer/bringoz-factory.factory";
import {PushNotificationsConfig} from "../../persistence-layer/models/push-notifications-config.model";
import {DataStoreConfig} from "../../persistence-layer/models/datastore-config.model";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.wallets')
  .factory('$walletsBalances', WalletsObjectFactory);

/* @ngInject */
function WalletsObjectFactory($bringozFactory: $bringozFactory,
                              WalletsBalancesAPI: BringozApi,
                              WalletsBalances_DS: DataStoreConfig,
                              WalletsBalances_PN: PushNotificationsConfig) {
  function $walletsBalances(id: string) {
    return $bringozFactory(id, WalletsBalancesAPI, WalletsBalances_DS, WalletsBalances_PN);
  }

  return $walletsBalances;
}


